import React, { useState, useRef, useEffect } from 'react';
import {
    Box,
    Input,
    IconButton,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from '@mui/icons-material/Close';

const StyledBox = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[400]}`, 
    borderRadius: theme.shape.borderRadius, 
    '&:hover': {
        borderColor: theme.palette.grey[900],
    },
}));

const InputLabel = styled(Typography)(({ theme, shrink }) => ({
    position: 'absolute',
    padding: shrink ? '0 4px' : '0',
    zIndex: 0,
    left: shrink ? theme.spacing(0.8) : theme.spacing(1.6),
    top: shrink ? '-9px' : '20%',
    backgroundColor: shrink ? theme.palette.background.paper : 'transparent',
    fontSize: shrink ? '0.75rem' : '1rem',
    color: theme.palette.text.secondary,
    lineHeight: '1.4375em',
    transition: theme.transitions.create(['left', 'top', 'background-color', 'padding', 'font-size']),
}));

export function ImageInput({ valueObjectURL, onChangeFile, allowedTypes, maxSizeMb }) {
    const [selectedImage, setSelectedImage] = useState(null);

    const inputRef = useRef(null);

    const _allowedTypes = allowedTypes !== undefined ? allowedTypes : 'image/png';
    const _value = valueObjectURL !== undefined ? valueObjectURL : selectedImage;
    const _setValue = (newBlob) => {
        if (valueObjectURL !== undefined) {
            onChangeFile && onChangeFile(newBlob);
        }
        if (valueObjectURL === undefined) {
            setSelectedImage(URL.createObjectURL(newBlob));
            onChangeFile && onChangeFile(newBlob);
        }
    }

    const defaultWidth = 200;
    const defaultHeight = 40;
    const defaultMaxWidth = 200;
    const defaultMaxHeight = 200;

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        handleImage(file);
        event.target.value = null;
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        handleImage(file);
        event.target.value = null;
    };

    const handleImage = (file) => {
        if (!file)
            return;

        const isAllowedSize = maxSizeMb ? file.size <= maxSizeMb * 1024 * 1024 : true;

        if (isAllowedSize && _allowedTypes.includes(file.type)) {
            console.log(file.type, file);
            _setValue(file);
        } else {
            _setValue(null);
        }
    };

    const onDelete = (event) => {
        event.stopPropagation();
        _setValue(null);
    };

    return (
        <StyledBox
            style={{
                minWidth: defaultWidth,
                minHeight: defaultHeight,
                maxWidth: defaultMaxWidth,
                maxHeight: defaultMaxHeight,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: "relative",
            }}
            variant='outlined'
            onClick={() => inputRef.current.click()}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
            <InputLabel
                shrink={_value ? 'true' : ''}
            >{_value ? 'Логотип' : 'Логотип (.png < 1мб)'}</InputLabel>
            <Input
                type="file"
                style={{ display: 'none' }}
                onChange={handleImageChange}
                inputRef={(ref) => (inputRef.current = ref)}
                inputProps={{
                    accept: _allowedTypes,
                }}
            />
            {_value && (
                <>
                    <Box sx={{ p: '16px', pb: '12px', zIndex: 2 }} >
                        <img
                            src={_value}
                            alt="Логотип"
                            style={{
                                borderRadius: 4,
                                maxWidth: defaultMaxWidth - 32,
                                maxHeight: defaultMaxHeight - 32,
                                zIndex: 2,
                                pointerEvents: 'none',
                                objectFit: 'contain',
                            }}
                        />
                    </Box>
                    <IconButton
                        aria-label="delete"
                        onClick={onDelete}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            zIndex: 3,
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </>
            )}
        </StyledBox>
    );
};